import type { EventView, ParticipantView, ScoreView } from "../api/types.js";
import { Countdown } from "./Countdown.js";

interface Props {
  event: EventView;
  participant: ParticipantView;
  score: ScoreView;
  online: boolean;
}

/**
 * 画面上部に固定するヘッダ。
 * 参加者が最も気にする「現在の得点」を常に見える位置に置く。
 */
export function Header({ event, participant, score, online }: Props): React.ReactElement {
  const owner =
    participant.team !== null
      ? participant.team.name
      : (participant.displayName ?? "あなた");

  return (
    <header className="header">
      <div className="header__row">
        <div className="header__meta">
          <p className="header__event">{event.name}</p>
          <p className="header__owner">
            {owner}
            {participant.team !== null && participant.displayName !== null && (
              <span className="header__member">（{participant.displayName}）</span>
            )}
          </p>
        </div>
        <div className="header__score">
          <span className="header__score-value">{score.displayScore}</span>
          <span className="header__score-unit">点</span>
        </div>
      </div>

      <div className="header__row header__row--sub">
        <p className="header__stats">
          正解 {score.solvedCount} ・ ヒント {score.hintCount} ・ 誤答 {score.wrongCount}
        </p>
        {/* 制限時間を設定しているときだけ出る。無制限なら何も描画しない */}
        <Countdown remainingSec={event.remainingSec} paused={event.stage === "paused"} />
        {!online && (
          <p className="header__offline" role="status">
            ● オフライン
          </p>
        )}
      </div>
    </header>
  );
}
